import {
  GET_ALLREVIEWS_FAIL,
  GET_ALLREVIEWS_REQUEST,
  GET_ALLREVIEWS_SUCCESS,
  GET_SINGLEREVIEW_FAIL,
  GET_SINGLEREVIEW_REQUEST,
  GET_SINGLEREVIEW_SUCCESS,
  UPDATE_REVIEW_FAIL,
  UPDATE_REVIEW_REQUEST,
  UPDATE_REVIEW_SUCCESS,
  CREATE_PRODUCTREVIEW_FAIL,
  CREATE_PRODUCTREVIEW_REQUEST,
  CREATE_PRODUCTREVIEW_SUCCESS,
  GET_PRODUCTREVIEW_FAIL,
  GET_PRODUCTREVIEW_REQUEST,
  GET_PRODUCTREVIEW_SUCCESS
} from "./reviewsTypes";

export const reviewsReducer = (state = {}, action) => {
  
  switch (action.type) {
    case GET_ALLREVIEWS_REQUEST:
      return { ...state, loading: true };
    case GET_ALLREVIEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        reviews: action.payload,
      };
    case GET_ALLREVIEWS_FAIL:
      return { loading: false, error: action.payload };
      
    case GET_SINGLEREVIEW_REQUEST:
      return { ...state, loading: true };
    case GET_SINGLEREVIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        review: action.payload,        
      };
    case GET_SINGLEREVIEW_FAIL:
      return { loading: false, error: action.payload };

    case UPDATE_REVIEW_REQUEST:
      return { ...state, loading: true };
    case UPDATE_REVIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        review: action.payload,
      };
    case UPDATE_REVIEW_FAIL:
      return { loading: false, error: action.payload };
      
      case GET_PRODUCTREVIEW_REQUEST:
        return { ...state, loading: true };
      case GET_PRODUCTREVIEW_SUCCESS:
        return {
          ...state,
          loading: false,
          productReviews: action.payload.reviews,
          totalReviews: action.payload.totalReviewCount
        };
      case GET_PRODUCTREVIEW_FAIL:
        return { loading: false, error: action.payload };
        
        case CREATE_PRODUCTREVIEW_REQUEST:
          return { ...state, loading: true };
        case CREATE_PRODUCTREVIEW_SUCCESS:
          return {
            ...state,
            loading: false,
            success: true,
          };
        case CREATE_PRODUCTREVIEW_FAIL:
          return { loading: false, error: action.payload };
    
    default:
      return state;
  }
};
